module.exports = __webpack_public_path__ + "static/media/complete-status.4c29b7a1.svg";